import { render, staticRenderFns } from "./ProjectSocialPlatformLinkedIn.vue?vue&type=template&id=63e00fa4"
import script from "./ProjectSocialPlatformLinkedIn.vue?vue&type=script&lang=ts"
export * from "./ProjectSocialPlatformLinkedIn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports